<template>
  <div class="text-center">
    <b-dropdown right variant="black" toggle-class="header-item">
      <template v-slot:button-content>
        <div v-if="selectedWorkspace" class="d-flex items-center justify-center gap-4">
          <i class="iconoir-hexagon text-white font-size-24 align-middle"></i>
          <div class="workspace-text">{{ selectedWorkspace.name }}</div>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block text-bigger"></i>
        </div>
        <span v-else>{{ $t("workspace.select") }}</span>
      </template>

      <b-dropdown-item-button
        v-for="workspace in pagination"
        :key="workspace._id"
        @click="select(workspace)"
        :disabled="(selectedWorkspace && workspace._id == selectedWorkspace._id) || workspace.isDeleting"
      >
        <i v-if="workspace.isDeleting" class="mdi mdi-progress-close mr-1"></i>
        <i v-else class="mdi mdi-hexagon-multiple-outline mr-1"></i>
        {{ workspace.name }}
      </b-dropdown-item-button>

      <div class="d-flex justify-content-center my-3">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-if="pagination" v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="10" @click.native.stop size="sm"></b-pagination>
        </ul>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      request: {
        options: { page: 1, limit: 30, sort: { name: "asc" } },
      },
    };
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      async handler() {
        await this.paginate();
      },
    },
  },

  computed: {
    pagination() {
      return this.$store.getters["switchWorkspace/pagination"]?.docs ?? [];
    },
    selectedWorkspace() {
      return this.$store.getters["switchWorkspace/selected"];
    },
  },

  methods: {
    select(workspace) {
      this.$store.commit("switchWorkspace/selected", workspace);
      location.reload();
    },
    paginate() {
      this.$store.dispatch(`switchWorkspace/paginate`, { pagination: this.request, showOnlyIfRequestedAccountisAdmin: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.workspace-text {
  margin: 0 0.5rem;
  color: #fff;
  leading-trim: both;
  text-edge: cap;
  font-family: "Roboto";
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
